// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.left-menu-container {
  margin-right: 15px;
}

.mb-20 {
  margin-bottom: 20px;
}

.mb-10 {
  margin-bottom: 10px;
}

.mt-15 {
  margin-top: 15px;
}

.muted {
  color: #666;
}

.no-top-margin {
  margin-top: 0;
}

.spinner-row {
  padding: 10px 0;
}

.row-align-end {
  align-items: flex-end;
}

.field-col {
  margin-bottom: 10px;
}

.field-label {
  display: block;
  font-weight: 600;
  margin-bottom: 4px;
}

.config-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 10px;
}

.loading-indicator {
  text-align: center;
  padding: 20px;
}

.job-status {
  margin-bottom: 15px;
}

.job-status__header {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}

.job-status__subtext {
  margin-top: 6px;
  color: #555;
}

.status-row {
  margin-bottom: 15px;
}

.status-actions {
  text-align: right;
}

.icon-16 {
  font-size: 16px;
  height: 16px;
  width: 16px;
  vertical-align: text-bottom;
}

.progress-wrapper {
  margin-bottom: 15px;
}

.progress-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}

.stat-col {
  margin-bottom: 15px;
}

.stat-card__value {
  margin: 0;
  font-size: 28px;
}

.stat-card__label {
  margin: 5px 0 0 0;
  color: #555;
}

.stat-card--users {
  background: #e3f2fd;
}

.stat-card__value--users {
  color: #1976d2;
}

.stat-card--inserted {
  background: #e8f5e9;
}

.stat-card__value--inserted {
  color: #388e3c;
}

.stat-card--updated {
  background: #fff3e0;
}

.stat-card__value--updated {
  color: #f57c00;
}

.stat-card--deactivated {
  background: #ffebee;
}

.stat-card__value--deactivated {
  color: #d32f2f;
}

.errors-list {
  margin-bottom: 0;
  padding-left: 20px;
}

.debug-card {
  border: 1px dashed #bbb;
}

.debug-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.actions-right {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.debug-result {
  overflow: auto;
}

.debug-result__meta {
  margin-bottom: 8px;
}

.debug-result__json {
  margin: 0;
  white-space: pre-wrap;
}

.empty-state {
  text-align: center;
  padding: 40px;
}

.empty-state__icon {
  font-size: 64px;
  height: 64px;
  width: 64px;
  color: #999;
}

.empty-state__title {
  font-size: 18px;
  color: #666;
  margin-top: 15px;
}

.empty-state__subtitle {
  color: #999;
}

.stat-card {
  padding: 15px;
  border-radius: 8px;
  transition: transform 0.2s;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.badge {
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.badge-primary {
  background-color: #2196f3;
  color: white;
}

.badge-success {
  background-color: #4caf50;
  color: white;
}

.badge-danger {
  background-color: #f44336;
  color: white;
}

.badge-secondary {
  background-color: #9e9e9e;
  color: white;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/users-sync/users-sync.component.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,aAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AAAF;;AAGA;EACE,eAAA;EACA,WAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,SAAA;EACA,eAAA;AAAF;;AAGA;EACE,iBAAA;EACA,WAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,gBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,uBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAAF;;AAGA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,SAAA;EACA,qBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,aAAA;AAAF;;AAGA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;AAAF;;AAGA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAGA;EACE,aAAA;EACA,kBAAA;EACA,0BAAA;AAAF;;AAGA;EACE,2BAAA;EACA,wCAAA;AAAF;;AAGA;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AAAF;;AAGA;EACE,yBAAA;EACA,YAAA;AAAF;;AAGA;EACE,yBAAA;EACA,YAAA;AAAF;;AAGA;EACE,yBAAA;EACA,YAAA;AAAF;;AAGA;EACE,yBAAA;EACA,YAAA;AAAF","sourcesContent":["// Add any component-specific styles here\n.left-menu-container {\n  margin-right: 15px;\n}\n\n.mb-20 {\n  margin-bottom: 20px;\n}\n\n.mb-10 {\n  margin-bottom: 10px;\n}\n\n.mt-15 {\n  margin-top: 15px;\n}\n\n.muted {\n  color: #666;\n}\n\n.no-top-margin {\n  margin-top: 0;\n}\n\n.spinner-row {\n  padding: 10px 0;\n}\n\n.row-align-end {\n  align-items: flex-end;\n}\n\n.field-col {\n  margin-bottom: 10px;\n}\n\n.field-label {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.config-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.loading-indicator {\n  text-align: center;\n  padding: 20px;\n}\n\n.job-status {\n  margin-bottom: 15px;\n}\n\n.job-status__header {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.job-status__subtext {\n  margin-top: 6px;\n  color: #555;\n}\n\n.status-row {\n  margin-bottom: 15px;\n}\n\n.status-actions {\n  text-align: right;\n}\n\n.icon-16 {\n  font-size: 16px;\n  height: 16px;\n  width: 16px;\n  vertical-align: text-bottom;\n}\n\n.progress-wrapper {\n  margin-bottom: 15px;\n}\n\n.progress-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 5px;\n}\n\n.stat-col {\n  margin-bottom: 15px;\n}\n\n.stat-card__value {\n  margin: 0;\n  font-size: 28px;\n}\n\n.stat-card__label {\n  margin: 5px 0 0 0;\n  color: #555;\n}\n\n.stat-card--users {\n  background: #e3f2fd;\n}\n\n.stat-card__value--users {\n  color: #1976d2;\n}\n\n.stat-card--inserted {\n  background: #e8f5e9;\n}\n\n.stat-card__value--inserted {\n  color: #388e3c;\n}\n\n.stat-card--updated {\n  background: #fff3e0;\n}\n\n.stat-card__value--updated {\n  color: #f57c00;\n}\n\n.stat-card--deactivated {\n  background: #ffebee;\n}\n\n.stat-card__value--deactivated {\n  color: #d32f2f;\n}\n\n.errors-list {\n  margin-bottom: 0;\n  padding-left: 20px;\n}\n\n.debug-card {\n  border: 1px dashed #bbb;\n}\n\n.debug-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.actions-right {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.debug-result {\n  overflow: auto;\n}\n\n.debug-result__meta {\n  margin-bottom: 8px;\n}\n\n.debug-result__json {\n  margin: 0;\n  white-space: pre-wrap;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 40px;\n}\n\n.empty-state__icon {\n  font-size: 64px;\n  height: 64px;\n  width: 64px;\n  color: #999;\n}\n\n.empty-state__title {\n  font-size: 18px;\n  color: #666;\n  margin-top: 15px;\n}\n\n.empty-state__subtitle {\n  color: #999;\n}\n\n.stat-card {\n  padding: 15px;\n  border-radius: 8px;\n  transition: transform 0.2s;\n}\n\n.stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n}\n\n.badge {\n  padding: 6px 12px;\n  border-radius: 4px;\n  font-size: 14px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.badge-primary {\n  background-color: #2196f3;\n  color: white;\n}\n\n.badge-success {\n  background-color: #4caf50;\n  color: white;\n}\n\n.badge-danger {\n  background-color: #f44336;\n  color: white;\n}\n\n.badge-secondary {\n  background-color: #9e9e9e;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
